const AuthTitle = () => (
  <>
    <h3 className="text-black font-bold text-center text-dark text-xl md:text-2xl">Automate Your Funnels Today</h3>
    <div className="text-black text-center text-sm mb-5 px-10">
      You're one step away of automating your marketing funnels and sales.
    </div>
  </>
);

export default AuthTitle;
